export default "__VITE_ASSET__Cnj_6uk2__"